import React from "react";

interface CompletionCardProps {
  completed: number;
  total: number;
  onClick: () => void;
}

const CompletionCard: React.FC<CompletionCardProps> = ({
  completed,
  total,
  onClick,
}) => {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div
      className="relative group cursor-pointer"
      onClick={onClick}
      data-testid="metric-card-completed"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl blur opacity-75 group-hover:opacity-100 transition-opacity" />
      <div className="relative bg-gradient-to-br from-emerald-500 via-emerald-600 to-teal-700 rounded-2xl p-5 border border-emerald-400/30 shadow-lg shadow-emerald-500/25">
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <div className="flex items-baseline gap-2">
              <p className="text-4xl font-black text-white drop-shadow-lg">
                {completed}
              </p>
              <span className="text-sm text-emerald-200 font-medium">
                / {total}
              </span>
            </div>
            <p className="text-sm font-semibold text-emerald-100 mt-1">
              Completed
            </p>
          </div>
          <div className="w-11 h-11 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm flex-shrink-0">
            <span className="text-xl">✓</span>
          </div>
        </div>
        <div className="mt-3">
          <div className="flex items-center justify-between mb-1.5">
            <span className="text-xs text-emerald-200 font-medium">
              Completion Rate
            </span>
            <span className="text-xs font-bold text-white">{pct}%</span>
          </div>
          <div className="w-full h-2 bg-white/20 rounded-full overflow-hidden">
            <div
              className="h-full bg-white/80 rounded-full transition-all duration-500"
              style={{ width: `${pct}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletionCard;
